import algoliasearch from 'algoliasearch';

const appId = 'Z0SDDVYUS0';
const searchApiKey = '32ae895c75fef56be3c752ad7c88ed0d';

const client = algoliasearch(appId, searchApiKey);
const investmentIndex = client.initIndex('Investment');

export { investmentIndex };
